import { Point } from '@/types';
import { Line } from './types';

export function getLine(v: Point, v2: Point): Line {
  if (v.y === v2.y) {
    return { y: v.y }; // horizontal line
  }

  if (v.x === v2.x) {
    return { x: v.x }; // vertical line
  }

  const m = (v2.y - v.y) / (v2.x - v.x);
  const b = v.y - m * v.x;

  return { m, b }; // angle line
}
